<button
  cuiButton
  class="tile"
  [class.tile--image]="!!previewUrl()"
  variant="grey"
  type="button"
  [title]="file().name"
  [attr.aria-label]="'Preview ' + file().name"
  (click)="openPreview()">
  @if (file().mimeType.startsWith('image/')) {
    @if (previewUrl(); as url) {
      <img [src]="url" alt="" />
    } @else {
      <span class="material-symbols-outlined" aria-hidden="true">image</span>
    }
  } @else {
    <span class="material-symbols-outlined" aria-hidden="true">description</span>
    <span class="file-name">{{ file().name }}</span>
  }
</button>
@if (removable()) {
  <button
    cuiButton
    class="remove"
    square
    size="small"
    variant="grey"
    type="button"
    [attr.aria-label]="'Remove ' + file().name"
    (click)="attachments.remove(file())">
    <span class="material-symbols-outlined" aria-hidden="true">close</span>
  </button>
}
